// extracted by mini-css-extract-plugin
export default {"chartContainer":"GlaciersChart_chartContainer__iP0kY"};